"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var TableRow = function (_a) {
    var bordered = _a.bordered, selected = _a.selected, branding = _a.branding, onClick = _a.onClick, testId = _a["data-testid"], children = _a.children, className = _a.className;
    var borderColors = (0, theme_1.useBorderColors)(branding);
    var stateColors = (0, theme_1.useBackgroundStateColors)(branding);
    return ((0, jsx_runtime_1.jsx)("tr", __assign({ "data-testid": testId || 'tableRow', onClick: onClick, className: (0, classnames_1.default)({
            'squid-bg-alias-state-base-active': selected,
            'squid-border-b': bordered,
        }, borderColors.base, stateColors.base, className) }, { children: children })));
};
exports.TableRow = TableRow;
